var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.number),function(i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"4"}},[_c('v-skeleton-loader',{staticClass:"ma-2 my-4",attrs:{"type":"card"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }